import React from "react";
import { Marker } from "react-map-gl";
export default function Pin({ point, children }: any) {
  return (
    <Marker
      longitude={point.geometry.coordinates[0]}
      latitude={point.geometry.coordinates[1]}
    >
      {children}
    </Marker>
  );
}
